// ANCHOR React
import { memo } from 'react';

// ANCHOR Models
import { UpdateFormQuestionPositionForm } from '@lyon/scoped-models/form/update/UpdateFormQuestionPositionForm';

// ANCHOR Components
import { LyonUpdateFormPositionModalContainer } from './LyonUpdateFormPositionModalContainer';
import { LyonUpdateFormPositionFormContainer } from './LyonUpdateFormPositionFormContainer';
import { LyonUpdateFormPositionSubmit } from './LyonUpdateFormPositionSubmit';
import { LyonUpdateFormPositionInput } from './LyonUpdateFormPositionInput';

export const LyonUpdateFormPosition = memo(() => (
  <LyonUpdateFormPositionModalContainer>
    <UpdateFormQuestionPositionForm.Provider>
      <LyonUpdateFormPositionFormContainer>
        <LyonUpdateFormPositionInput />
        <LyonUpdateFormPositionSubmit />
      </LyonUpdateFormPositionFormContainer>
    </UpdateFormQuestionPositionForm.Provider>
  </LyonUpdateFormPositionModalContainer>
));
